// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ba5ec1a7","865":"36b388c5"}[chunkId] + ".chunk.js";
};